import apiBanner from '@/api/public/banner';

const defaultState = () => ({
	banner: [],
	loadBanner: false,
	detailBanner: {},
	bannerPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {
};

const mutations = {
	setBanner(state, data) {
		state.banner = data.data
		state.bannerPagination = data.pagination;
	},
	setLoadBanner(state, data) {
		state.loadBanner = data
	},
	setDetailBanner(state, data) {
		state.detailBanner = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearBanner(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	async getBanner({ commit }, params) {
		commit('setLoadBanner', true);
		return new Promise((resolve) => {
			apiBanner.getBanner(params).then(({ data: { data } }) => {
				commit('setBanner', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setBanner', { data: [], pagination: {} });
			}).then(() => {
				commit('setLoadBanner', false);
			});
		});
	},
	async getBannerRaw({ commit }, params) {
		commit('setLoadBanner', true);
		return new Promise((resolve) => {
			apiBanner.getBanner(params).then(({ data: { data } }) => {
				// commit('setBanner', { data: data.results, pagination: data.pagination });
				resolve(data.results);
			}).catch(() => {
				// commit('setBanner', { data: [], pagination: {} });
				commit('setLoadBanner', false);

			}).then(() => {
				commit('setLoadBanner', false);
			});
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('failed', { code: 'error_response', type: 'error', message: response.message });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};